import React from "react";
import Box from "ReusableComponents/Box";
import ChargingHub from "assets/ICONS04.svg";
import OnboardCharger from "assets/ICONS02.svg";
import FastCharger from "assets/ICONS01.svg";
import Charging from "assets/ICONS03.svg";
import IconHolder from "./IconHolder";
import { Grid, useMediaQuery } from "@mui/material";
import { HOST } from "api/apiClient";

const setImage = (title) => {
  switch (title) {
    case "Fast":
      return FastCharger;
    case "Home":
      return OnboardCharger;
    case "Wheels":
      return ChargingHub;
    default:
      return Charging;
  }
};

const IconBox = ({ allfeatures, small }) => {
  const medium = useMediaQuery("(max-width: 900px)");

  const data = allfeatures.map((item) => ({
    ...item,
    img: item?.attributes?.media?.data?.attributes?.url,
  }));
  return (
    <Box
      display="flex"
      margin={small || medium ? 0 : "40px "}
      justifyContent="space-between"
    >
      <Grid container spacing={2}>
        {data.map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item.id}>
            <IconHolder
              small={small}
              Icon={item?.img}
              name={item?.attributes?.title}
              desc={item?.attributes?.description}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default IconBox;
